import localStorage from '@/utils/localStorage'
import _ from '@/utils/datetime'
import { AuthError } from '@/DATA/error'

export default () => {
  const authcode = localStorage.get('authcode')
  if (authcode) {
    let refreshExpiretime = localStorage.get('refreshExpiretime')
    refreshExpiretime = refreshExpiretime ? _.toDate(refreshExpiretime).getTime() : null
    
    if (refreshExpiretime && refreshExpiretime > Date.now() || !refreshExpiretime) { // refreshcode未过期或者refreshcode过期时间为空
      return Promise.resolve({ authcode })
    } else {
      return Promise.reject(AuthError['0000'])
    }

  } else {
    return Promise.reject(AuthError['0001'])
  }
}



// WEBPACK FOOTER //
// ./src/utils/verifyToken.js